const baseUrl = `${process.env.REACT_APP_API_URL}/api`;
const msApiUrl = process.env.REACT_APP_MS_API_URL;
const segaUrl = process.env.REACT_APP_SEGA_URL;
const n8nUrl = `${process.env.REACT_APP_N8N_API_URL}/webhook`;
const integrationUrl = process.env.REACT_APP_INTEGRATIONS_URL;
const cdnHost = process.env.REACT_APP_CDN_HOST;

export const GOOGLE_MAPS_API_KEY =
  process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '';

export default {
  auth: {
    login: `${process.env.REACT_APP_API_URL}/apptoken`,
    recover: `${baseUrl}/customeradmin/sendrecoverypassword?Email=`,
    confirm: `${baseUrl}/customeradmin/recoverypassword`,
  },
  profile: {
    load: `${baseUrl}/profile/load`,
    paquerypointInfo: (pqPointId) =>
      `${msApiUrl}/pqpoint/paquerypoint/${pqPointId}`,
  },
  globals: {
    packageType: `${msApiUrl}/packages/parametrics/packageType`,
    packageSize: `${msApiUrl}/packages/parametrics/packageSize`,
    packageStatus: `${msApiUrl}/packages/parametrics/packageStatus`,
    deliveryPackageType: `${msApiUrl}/packages/parametrics/deliveryPackageType`,
    deliveryTerm: `${msApiUrl}/packages/parametrics/deliveryTerm`,
    countries: `${baseUrl}/geolocation/loadcountries`,
    cities: `${baseUrl}/geolocation/loadcities`,
    roles: `${baseUrl}/apptype/userrole`,
    userType: `${baseUrl}/apptype/usertype`,
    dispatchTypes: `${msApiUrl}/packages/parametrics/dispatchType`,
    notifierType: `${msApiUrl}/mkp/parametrics/notifierType`,
    daysOfWeek: `${msApiUrl}/pqpoint/paquerypoint/daysOfWeek`,
    currentServices: `${msApiUrl}/pqpoint/paquerypoint/currentServices`,
  },
  notifications: {
    root: `${msApiUrl}/notifications`,
    markAsSeen: (id) => `${msApiUrl}/notifications/${id}/seen`,
    markAllAsSeen: `${msApiUrl}/notifications/mark-all-seen`,
    refreshToken: `${msApiUrl}/notifications/notification-preferences/refresh-token`,
    created: `${msApiUrl}/notifications/created`,
  },
  notificationHub: {
    config: (ownerType, ownerId) =>
      `${msApiUrl}/notify/config/${ownerType}/${ownerId}`,
    gallery: `${msApiUrl}/notify/gallery`,
    templates: `${msApiUrl}/notify/templates`,
    template: (id) => `${msApiUrl}/notify/templates/${id}`,
    preview: (id) => `${msApiUrl}/notify/templates/${id}/preview`,
  },
  packages: {
    get: `${msApiUrl}/packages/packages`,
    getById: `${msApiUrl}/packages/packages/`,
    getByExternalCode: `${msApiUrl}/packages/packages/findByExternalCode`,
    getByExternalCodeFromArrivedOrDispatch: `${msApiUrl}/packages/packages/findByExternalCodeFromArrivedOrDispatch`,
    findByExternalCodeDispatch: `${msApiUrl}/packages/dispatch/findByExternalCode`,
    history: `${msApiUrl}/packages/packages/history`,
    updateStatus: `${msApiUrl}/packages/packages/searchArrived/`,
    arrivePacket: `${msApiUrl}/packages/packages/arrivals`,
    arrivePacketByID: (id) => `${msApiUrl}/packages/packages/arrive/id/${id}`,
    deliverPickup: `${msApiUrl}/packages/packages/pickup/delivery`,
    deliverPickupByID: (id) => `${msApiUrl}/packages/pickup/arrive/id/${id}`,
    withPaquers: `${msApiUrl}/packages/packages/withPaquers`,
    withoutZone: `${msApiUrl}/packages/packages/withoutzone`,
    withPaquersHistorical: `${msApiUrl}/packages/packages/history`,
    label: `${msApiUrl}/labels/packages/`,
    isPackageBundle: `${msApiUrl}/packages/packages/isPackageBundle`,
    downloadDeliveryNoteById: (id) =>
      `${msApiUrl}/labels/packages/remittance/${id}`,
    // OPL
    send: `${msApiUrl}/packages/packages`,
    labelByMassive: (code) => `${msApiUrl}/labels/packages/massive/${code}`,
    assignPackages: `${msApiUrl}/packages/paquer/acceptpackages/`,
    getByMassiveCode: `${msApiUrl}/packages/massive/packages/list`,
    getNormalByStoreId: (storeId) =>
      `${msApiUrl}/packages/packages/packagesByStoreId/${storeId}`,
    getHistoryByStoreId: (storeId) =>
      `${msApiUrl}/packages/packages/packagesHistoryByStoreId/${storeId}`,
  },
  assignee: {
    drivers: {
      getAll: `${msApiUrl}/assignee/driver`,
      create: `${msApiUrl}/assignee/driver`,
      deleteById: (id) => `${msApiUrl}/assignee/driver/${id}`,
    },
    routes: {
      getAll: `${msApiUrl}/assignee/route`,
      getById: (id) => `${msApiUrl}/assignee/route/${id}`,
      downloadReportByRouteId: (routeId) =>
        `${msApiUrl}/assignee/route/${routeId}/report`,
    },
  },
  massive: {
    list: `${msApiUrl}/packages/massive`,
    packagesUpload: (userId) =>
      `${msApiUrl}/caronte/integration/${userId}/massive`,
    packagesDownload: `${cdnHost}/assets/bulk-import.xlsx`,
  },
  segaMassive: {
    root: `${segaUrl}/api/massive`,
    byId: (id) => `${segaUrl}/api/massive/${id}`,
    errors: (id) => `${segaUrl}/api/massive/${id}/errors`,
    labels: (id) => `${segaUrl}/api/massive/${id}/labels`,
    packages: (id) => `${segaUrl}/api/massive/${id}/packages`,
    packageByTracking: (id, tracking) =>
      `${segaUrl}/api/massive/${id}/packages/${tracking}`,
    packageLabel: (id, tracking) =>
      `${segaUrl}/api/massive/${id}/packages/${tracking}/label`,
    cancel: (id) => `${segaUrl}/api/massive/${id}/cancel`,
    cancelPackage: (id, tracking) =>
      `${segaUrl}/api/massive/${id}/packages/${tracking}/cancel`,
    template: `${segaUrl}/api/massive/template`,
  },
  segaShipment: {
    create: `${segaUrl}/api/shipment`,
    label: (tracking) => `${segaUrl}/api/shipment/${tracking}/label`,
  },
  departures: {
    create: `${msApiUrl}/packages/dispatch`,
    getAll: `${msApiUrl}/packages/dispatch`,
    getById: (dispatchId) =>
      `${msApiUrl}/packages/dispatch/packages/${dispatchId}`,
    receipt: (dispatchId) =>
      `${msApiUrl}/labels/dispatch/receipt/${dispatchId}`,
    getPackagesNotArrivedByCode: (dispatchCode) =>
      `${msApiUrl}/packages/dispatch/packages/notArrived?qrCode=${dispatchCode}`,
  },
  paquer: {
    get: `${msApiUrl}/packages/packages`,
    getById: `${msApiUrl}/pqr/paquer/`,
    getPackages: `${msApiUrl}/packages/packages/current/byDriver/`,
    // Dali directo, solo lo usa el legacyRoute; no valida rutas ajenas
    assign: `${msApiUrl}/packages/packages/searchRolled/`,
    getAll: `${msApiUrl}/pqr/paquer`,
    assignShipment: (packageId) =>
      `${msApiUrl}/journeys/shipment/${packageId}/assign`,
    unassign: (packageId) =>
      `${msApiUrl}/journeys/shipment/${packageId}/unassign`,
    history: `${msApiUrl}/packages/packages/byDriver/`,
    // OPL
    create: `${msApiUrl}/pqr/paquer/`,
    update: `${msApiUrl}/pqr/paquer/`,
    delete: `${msApiUrl}/pqr/paquer/`,
  },
  paqueryPoint: {
    getAll: `${msApiUrl}/pqpoint/paquerypoint/availables`,
    // OPL
    get: `${msApiUrl}/pqpoint/paquerypoint`,
    getByIds: `${msApiUrl}/pqpoint/paquerypoint/paquerypointbyids`,
    getAllUnrelatedToOpl: `${msApiUrl}/pqpoint/paquerypoint/availables`,
    create: `${msApiUrl}/pqpoint/paquerypoint`,
    update: `${msApiUrl}/pqpoint/paquerypoint`,
    getPackages: `${msApiUrl}/packages/packages/packagesByPaqueryPointId`,
    getHistory: `${msApiUrl}/packages/packages/packagesHistoryByPaqueryPointId`,
    assign: `${msApiUrl}/packages/packages/searchArrived/`,
  },
  marketplaces: {
    get: `${msApiUrl}/mkp/marketplace`,
    getById: (mkpId) => `${msApiUrl}/mkp/marketplace/${mkpId}`,
    // OPL
    create: `${msApiUrl}/mkp/marketplace/create`,
    update: `${msApiUrl}/mkp/marketplace/update/`,
    delete: `${msApiUrl}/mkp/marketplace`,
  },
  stores: {
    getById: (id) => `${msApiUrl}/mkp/store/${id}`,
    getByMarketplace: `${msApiUrl}/mkp/store/marketplace`,
    // OPL
    create: `${msApiUrl}/mkp/store`,
    delete: `${msApiUrl}/mkp/store`,
  },
  reports: {
    history: `${msApiUrl}/reports/report/history`,
    packagesbyPaquer: `${msApiUrl}/reports/report/packagesWithPaquers`,
    packagesOwnedByPaquer: `${n8nUrl}/reports/by-driver`,
    historyByPaquer: `${msApiUrl}/reports/report/paquer/history`,
    withoutZone: `${msApiUrl}/reports/report/withoutzone`,
    packages: `${msApiUrl}/reports/report`,
    // OPL
    withPaqueryPoint: `${msApiUrl}/reports/report/paqueryPoint`,
    historyWithPaqueryPoint: `${msApiUrl}/reports/report/paqueryPoint/history`,
    storePackages: `${msApiUrl}/reports/report/store`,
    storeHistoryPackages: `${msApiUrl}/reports/report/store/history`,
  },
  zone: `${msApiUrl}/zones`,
  zones: {
    getAllByLogisticOperator: (id) =>
      `${msApiUrl}/zones/logistics_operator/${id}`,
    resolve: `${msApiUrl}/mediator/resolveZone`,
    // OPL
    deleteById: (id) => `${msApiUrl}/zones/${id}`,
    getAllWithGeoJsonByLogisticOperator: (id) =>
      `${msApiUrl}/zones/logistics_operator/${id}/full`,
    getGroupingWithGeoJsonByLogisticOperator: (id) =>
      `${msApiUrl}/zones/logistics_operator/${id}/grouping`,
    grouping: `${msApiUrl}/zones/groups`,
  },
  rates: {
    trunk: {
      root: `${msApiUrl}/rates/trunk`,
      byId: (rateId) => `${msApiUrl}/rates/trunk/${rateId}`,
      allByOpl: (oplId) => `${msApiUrl}/rates/trunk/logistic_operator/${oplId}`,
    },
    lastMile: {
      root: `${msApiUrl}/rates/last_mile`,
      byId: (rateId) => `${msApiUrl}/rates/last_mile/${rateId}`,
      allByOpl: (oplId) =>
        `${msApiUrl}/rates/last_mile/logistic_operator/${oplId}`,
    },
  },
  interbank: {
    link: (code) => `${integrationUrl}/cards/${code}`,
    checkByTrackcode: (trackCode) => `${integrationUrl}/cards/tc/${trackCode}`,
    stateByCode: (code) => `${integrationUrl}/cards/${code}`,
  },
  user: {
    getAll: `${baseUrl}/customeradmin/getall/`,
    update: `${baseUrl}/customeradmin/update`,
    // OPL
    changePassword: `${baseUrl}/customeradmin/sendrecoverypassword`,
    get: `${baseUrl}/customeradmin/get?id=`,
    delete: `${baseUrl}/customeradmin/delete?id=`,
    create: `${baseUrl}/customeradmin/create`,
  },
  logisticOperator: {
    getAll: `${msApiUrl}/opl/integration/opl/availables`,
  },
  alert: `${msApiUrl}/fe/messages`,
  whatsapp: {
    sendMessage: 'https://web.whatsapp.com/send?phone=',
  },
  journeys: {
    declare: (driverId) => `${msApiUrl}/journeys/declare/${driverId}`,
    serviceType: (id) => `${msApiUrl}/journeys/${id}/serviceType`,
    assignDriver: (id) => `${msApiUrl}/journeys/${id}/assignDriver`,
    create: `${msApiUrl}/journeys`,
    offer: (id) => `${msApiUrl}/journeys/${id}/offer`,
    shipment: (id) => `${msApiUrl}/journeys/${id}/shipments`,
    remove: (id, shipmentId) =>
      `${msApiUrl}/journeys/${id}/shipments/${shipmentId}`,
    getAuditLog: (id) => `${msApiUrl}/journeys/${id}/audit`,
    roadsheet: (id) => `${msApiUrl}/journeys/${id}/roadsheet`,
    list: `${msApiUrl}/journeys`,
    unassignDriver: (id) => `${msApiUrl}/journeys/${id}/unassignDriver`,
    dismantle: (id) => `${msApiUrl}/journeys/${id}/dismantle`,
    forceEnd: (id) => `${msApiUrl}/journeys/${id}/forceEnd`,
    redraft: (id) => `${msApiUrl}/journeys/${id}/deoffer`,
    get: (id) => `${msApiUrl}/journeys/${id}/minimal`,
    setOrigin: (id) => `${msApiUrl}/journeys/${id}/changeOrigin`,
    setSchedule: (id) => `${msApiUrl}/journeys/${id}/schedule`,
    join: (id) => `${msApiUrl}/journeys/${id}/join`,
    cancelTransfer: (id) =>
      `${msApiUrl}/journeys/${id}/transfer/cancel/byOperator`,
    transfer: (id) => `${msApiUrl}/journeys/${id}/transfer`,
    transferByOperator: (id) =>
      `${msApiUrl}/journeys/${id}/transfer/byOperator`,
    collections: (id) => `${msApiUrl}/journeys/${id}/collections`,
    collection: (id, collectionId) =>
      `${msApiUrl}/journeys/${id}/collections/${collectionId}`,
    releaseCollectionWait: (id, collectionId) =>
      `${msApiUrl}/journeys/${id}/collections/${collectionId}/releaseWait`,
    vehiclePlates: `${msApiUrl}/journeys/vehicle-plates`,
    name: (id) => `${msApiUrl}/journeys/${id}/name`,
    kind: (id) => `${msApiUrl}/journeys/${id}/kind`,
    templates: `${msApiUrl}/journeys/templates`,
    template: (id) => `${msApiUrl}/journeys/templates/${id}`,
    templateLogs: (id) => `${msApiUrl}/journeys/templates/${id}/logs`,
    instantiateTemplate: (id) =>
      `${msApiUrl}/journeys/templates/${id}/instantiate`,
  },
  collectionsV2: {
    list: `${msApiUrl}/collections/v2`,
    create: `${msApiUrl}/collections/v2`,
    detail: (id) => `${msApiUrl}/collections/v2/${id}`,
    cancel: (id) => `${msApiUrl}/collections/v2/${id}`,
    update: (id) => `${msApiUrl}/collections/v2/${id}`,
    ingest: (id) => `${msApiUrl}/collections/v2/${id}/ingest`,
    fulfill: (id) => `${msApiUrl}/collections/v2/${id}/fulfill`,
    codes: (id) => `${msApiUrl}/collections/v2/${id}/codes`,
    points: `${msApiUrl}/collections/v2/points`,
    point: (id) => `${msApiUrl}/collections/v2/points/${id}`,
    shifts: (id) => `${msApiUrl}/collections/v2/points/${id}/shifts`,
    shift: (id, shiftId) =>
      `${msApiUrl}/collections/v2/points/${id}/shifts/${shiftId}`,
  },
  routes: {
    getAllStarted: `${msApiUrl}/pq-router/route/getroutestarted`,
    getById: (id) => `${msApiUrl}/pq-router/route/getroutedetaill/${id}`,
    getActiveByPaquerId: `${msApiUrl}/pq-router/route/driver/packages/info`,
    history: `${msApiUrl}/pq-router/route/getroutehistory`,
    endRouteById: (id) => `${msApiUrl}/pq-router/route/setstate-end/${id}`,
    recreateRouteById: (id) => `${msApiUrl}/pq-router/route/recalculate/${id}`,
    generateByPaquer: `${msApiUrl}/pq-router/vrp/driver/create-route`,
  },
  adresses: {
    calculate: `${msApiUrl}/mediator/address/calculate`,
    alternativesByShipmentId: (shipmentId) =>
      `${msApiUrl}/mediator/shipment/${shipmentId}/address`,
    recalculate: (shipmentId) =>
      `${msApiUrl}/mediator/shipment/${shipmentId}/address/calculate`,
    addressByShipmentId: (shipmentId) =>
      `${msApiUrl}/mediator/shipment/${shipmentId}/address/current`,
    historyByShipmentId: (shipmentId) =>
      `${msApiUrl}/mediator/shipment/${shipmentId}/address/history`,
  },
  delivery: {
    historyByShipmentId: (shipmentId) =>
      `${msApiUrl}/mediator/shipment/${shipmentId}/pod/history`,
    visitsByShipmentId: (shipmentId) =>
      `${msApiUrl}/mediator/shipment/${shipmentId}/visits`,
    create: `${msApiUrl}/mediator/shipment/delivery`,
    attempt: `${msApiUrl}/mediator/shipment/delivery/attempt`,
  },
  physicalAttributes: {
    byShipmentId: (shipmentId) =>
      `${msApiUrl}/mediator/shipment/${shipmentId}/dimensions`,
  },
};
